export const baseUrl = "iris-ibmm-afg.gsf.amazon.dev/";

export const emptyAuthDetails = {
    username: "",
    email: ""
};

export const shipmentSummariesAPIRange = {
    min: -14,
    max: 14
};

export const defaultResultsPerPage = 10;

export const resultsPerPageOptions = [10, 25, 50, "All"];

export const ticketLinkBoxCharacterLimit = 100;

export const basicTempZones = ["AMBIENT", "CHILLED", "FROZEN"];

export const detailedTempZones = ["AMBIENT", "CHILLED", "FROZEN", "PRODUCE", "PROTEIN"];

export const shipmentQuantityKeys = {
    vendorConfirmedUnits: "quantityConfirmed",
    transConfirmedUnits: "manifestQuantity",
    vendorReceivedUnits: "quantityReceived",
    transReceivedUnits: "wmsQuantityReceivedStow",
    vendorTotalConfirmedUnits: "totalQuantityConfirmed",
    transTotalConfirmedUnits: "totalManifestQuantity",
    vendorTotalReceivedUnits: "totalQuantityReceived",
    transTotalReceivedUnits: "totalQuantityReceivedWmsStow",
}

export const slaShipmentProgressThreshold = 97;

export const loadIdDisplayLength = 15;

export const unscheduledVendorName = 'PO Pending Schedule';
export const notYetManifestedName = 'Not Yet Manifested';

export const discardableAppointmentStatuses = ["CLOSED"];

const hasDiscardableStatus = (appointment) =>
    discardableAppointmentStatuses.some(
        (status) => status.toUpperCase() === (appointment?.status || "").toUpperCase()
    );

export const filterDisplayAppointments = (appointments) => {
    if (!Array.isArray(appointments) || appointments.length <= 1) {
        return appointments || [];
    }
    return appointments.filter(
        (appointment) =>
            !(hasDiscardableStatus(appointment) && appointment?.checkInTime == null)
    );
};

// Parent-Child Conversion Toggle
// Set to 1 to enable parent-child conversion using yield values
// Set to 0 to disable conversion (use yield = 1 for all)
export const convertParentChild = 1;
// turn to 1 to stop conversion